export default {
  '概况':'概况',
  '展示当前最新数据':'展示当前最新数据',
  '人已参加运动':'人已参加运动',
  '完成任意一项运动':'完成任意一项运动即算参与运动，包括：作业、体锻、体测、教学、赛事',
  '学生人数':'学生人数',
  '班级数量':'班级数量',
  '教职工数量':'教职工数量',
  '设备数量':'设备数量',
  '加载中':'加载中...',
  '自主锻炼':'自主锻炼',
  '数据来源':'数据来源为校内外自由锻炼、趣味锻炼、竞技场场景，不包括作业、赛事等场景',
  '自主锻炼情况':'自主锻炼情况',
  '各年级自主锻炼情况':'各年级自主锻炼情况',
  '各年级锻炼时长':'各年级锻炼时长',
  '各项目锻炼时长':'各项目锻炼时长',
  '各年级每日锻炼时长对比':'各年级每日锻炼时长对比',
  '各年级锻炼参与趋势':'各年级锻炼参与趋势',
  '国家学生体质健康测试':'国家学生体质健康测试',
  '数据来源为国家学生体质健康测试板块':'数据来源为国家学生体质健康测试板块',
  '测试人数':'测试人数',
  '成绩分布':'成绩分布',
  '各年级成绩分布':'各年级成绩分布',
  '总分(下拉筛选项目)':'总分(下拉筛选项目)',
  '男生':'男生',
  '女生':'女生',
  '参与率':'参与率',
  '总人数':'总人数',
  '参与人数':'参与人数',
  '参与率（%）':'参与率（%）',
  '人数':'人数',
  '时长(分钟)':'时长(分钟)',
  '运动时长':'运动时长',
  '分钟':'分钟',
  '占比':'占比',
  '总计':'总计',
  '人':'人',
  '参与测试':'参与测试',
  '未参与测试':'未参与测试',
  '优秀':'优秀',
  '良好':'良好',
  '及格':'及格',
  '不及格':'不及格',
  '正常':'正常',
  '低体重':'低体重',
  '超重':'超重',
  '肥胖':'肥胖',
  '(本学年)':'(本学年)',
  '(本学期)':'(本学期)',
  '查看班级数据':'查看班级数据',
  '各班级参与运动情况':'各班级参与运动情况',
  '各班级运动时长':'各班级运动时长',
  '各项目运动时长':'各项目运动时长',
  '各班级每日锻炼时长对比':'各班级每日锻炼时长对比',
  '各班级锻炼参与趋势':'各班级锻炼参与趋势',
  '人均':'人均',
  '总数':'总数',
  '各班级成绩分布':'各班级成绩分布',
  '参与运动情况':'参与运动情况',
  '年级':'年级',
  '班级列表':'班级列表',
  '班级详情':'班级详情',
  '课堂看板':'课堂看板',
  '个人数据':'个人数据',
  '今日活跃':'今日活跃',
  '本周活跃':'本周活跃',
  '查看学生数据':'查看学生数据',
  '自主锻炼人数':'自主锻炼人数',
  '每日运动人数':'每日运动人数',
  '每日运动时长':'每日运动时长',
  '运动时长TOP5':'运动时长TOP5',
  '测试概况':'测试概况',
  '各项目平均分':'各项目平均分',
  '年级平均':'年级平均',
  '成绩及格率':'成绩及格率',
  '总时长':'总时长',
  '人均时长':'人均时长',
  '学生列表':'学生列表',
  '关键字搜索':'关键字搜索',
  '个人画像':'个人画像',
  '今日运动':'今日运动',
  '班级排名':'班级排名',
  '本周运动':'本周运动',
  '日均时长':'日均时长',
  '运动处方':'运动处方',
  '体质测试结果':'体质测试结果',
  '身体素质评估':'身体素质评估',
  '身体机能':'身体机能',
  '身体素质':'身体素质',
  '身体形态':'身体形态',
  '班级平均':'班级平均',
  '个人运动时长':'个人运动时长',
  '我':'我',
  '我的平均分':'我的平均分',
  '班级平均分':'班级平均分',
  '时长（分钟）':'时长（分钟）',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
  'aaaaaaaaaaa':'aaaaaaaaaaa',
}